import { useMemo } from 'react';
import { IUpcomingPourEventResponse } from 'types';
import { translations } from 'app/locales/i18n';
import { useTranslation } from 'react-i18next';
import { formatTimeWithDateIfNotToday } from 'app/shared/utils/formatTimeWithDate';

interface IInfoValue {
  title: string;
  content: {
    value: string;
    label: string;
    age?: string;
  }[];
}

export const useUpcomingDetailsInfoValues = (
  upcomingPourEvent: IUpcomingPourEventResponse,
) => {
  const { t } = useTranslation();

  const values: IInfoValue[] = useMemo(() => {
    return [
      {
        title: t(translations.upcomingDetailsModal.orderInformation),
        content: [
          {
            value: `${upcomingPourEvent.customerId} / ${upcomingPourEvent.customerName}`,
            label: t(translations.upcomingDetailsModal.customer),
          },
          {
            value: `${upcomingPourEvent.projectId} / ${upcomingPourEvent.projectName}`,
            label: t(translations.upcomingDetailsModal.project),
          },
          {
            value: `${upcomingPourEvent.productId} / ${upcomingPourEvent.productName}`,
            label: t(translations.upcomingDetailsModal.product),
          },
          {
            value: `${upcomingPourEvent.originId} / ${upcomingPourEvent.originName}`,
            label: t(translations.upcomingDetailsModal.origin),
          },
          {
            value: upcomingPourEvent.statusCode,
            label: t(translations.upcomingDetailsModal.status),
          },
          {
            value: formatTimeWithDateIfNotToday(
              upcomingPourEvent.dispatchDateTimeUtc,
            ),
            label: t(translations.upcomingDetailsModal.dispatchDate),
          },
          {
            value: upcomingPourEvent.totalOrderedQuantity?.toString() ?? '-',
            label: t(translations.upcomingDetailsModal.totalOrder),
          },
          {
            value: upcomingPourEvent.totalLoads?.toString() ?? '-',
            label: t(translations.upcomingDetailsModal.totalLoads),
          },
          {
            value: `${upcomingPourEvent.destinationCity}, ${upcomingPourEvent.destinationState} ${upcomingPourEvent.destinationCountry}`,
            label: t(translations.upcomingDetailsModal.location),
          },
        ],
      },
    ];
  }, [t, upcomingPourEvent]);

  return {
    upcomingDetailsInfoValues: values,
  };
};
